/** The API's look (Studio's keys and MCP) on the dashboard, header button and drawer. */
export const API_ACCENT = "#2dd4bf";
export const API_ACCENT_SOFT = "rgba(45, 212, 191, 0.12)";

export const CARD = "rounded-xl border border-[#2a475e] bg-[#131c28] p-5 md:p-6";

export const BTN_PRIMARY =
  "inline-flex items-center justify-center gap-2 rounded-lg bg-[#66c0f4] px-4 py-2 text-sm font-semibold text-[#0d151e] transition-colors hover:brightness-110 disabled:cursor-not-allowed disabled:opacity-60";

export const BTN_SECONDARY =
  "inline-flex items-center justify-center gap-2 rounded-lg border border-[#2a475e] bg-[#16202d] px-4 py-2 text-sm font-medium text-[#c7d5e0] transition-colors hover:border-[#3a556e] hover:bg-[#1f2e3f] hover:text-white disabled:cursor-not-allowed disabled:opacity-60";

export const BTN_DANGER =
  "inline-flex items-center justify-center gap-2 rounded-lg border border-red-400/40 bg-red-500/10 px-4 py-2 text-sm font-semibold text-red-200 transition-colors hover:bg-red-500/20 disabled:cursor-not-allowed disabled:opacity-60";

export const INPUT =
  "w-full rounded-lg border border-[#2a475e] bg-[#0f1923] px-3 py-2 text-sm text-white placeholder:text-[#5c6b7a] focus:border-[#66c0f4] focus:outline-none focus:ring-2 focus:ring-[#66c0f4]/25";
